import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import { useApi } from "../../context/api.js";

function HomeworkCategorySelect({ value, onChange, disabled }) {
  const api = useApi();

  // class
  const [loading, setLoading] = useState(true);
  const [choices, setChoices] = useState([]);
  const [input, setInput] = React.useState("");

  // TODO : Move to selectors
  useEffect(() => {
    api.getHomeworkCategories().then((res) => {
      setChoices(res);
      setLoading(false);
    });
  }, []);

  const handleInputChange = (event, newInputValue, reason) => {
    setInput(newInputValue);
  };

  return (
    <Autocomplete
      disabled={disabled}
      disableClearable
      id="categories"
      value={value || null}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      inputValue={input}
      onInputChange={handleInputChange}
      options={choices}
      loading={loading}
      loadingText="Recherche..."
      noOptionsText={
        input && !loading
          ? "Pas de résultat."
          : "Saisissez quelques caractères pour rechercher une classe."
      }
      getOptionLabel={(option) => option.name}
      fullWidth
      sx={{ mt: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Catégorie"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
HomeworkCategorySelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default HomeworkCategorySelect;
